import React from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const checkoutLink = 'https://kit-online-2026.myshopify.com/cart/44204549144711:1';
  return <section id="pricing" className="bg-[#0a0e27] py-5 md:py-16 px-4 font-sans" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white text-center italic mb-4 md:mb-8" data-id="element-155">
          Oferta Especial
        </h2>

        {/* Single Offer Card */}
        <div className="max-w-lg mx-auto mb-4 md:mb-8" data-id="element-156">
          <div className="relative bg-[#111638] rounded-xl p-4 pt-8 md:p-6 md:pt-10 text-center border-2 border-[#f97316] shadow-[0_0_30px_rgba(249,115,22,0.2)]" data-id="element-157">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#f97316] text-white text-sm font-bold px-4 py-1 rounded-full flex items-center gap-1.5 shadow-lg whitespace-nowrap" data-id="element-158">
              ⭐ Más elegido
            </div>
            <div className="text-5xl mb-4" data-id="element-159">🔨</div>
            <h3 className="text-2xl font-bold text-white italic mb-1" data-id="element-160">
              Mega Pack Acero-Madera
            </h3>
            <p className="text-gray-400 text-sm mb-4" data-id="element-161">
              500+ recursos, planos, guías paso a paso
            </p>
            <div className="text-5xl font-black text-white tracking-tight leading-none mb-2" data-id="element-162">
              $19.99 <span className="text-2xl" data-id="element-163">USD</span>
            </div>
            <div className="text-gray-500 line-through text-lg font-medium decoration-red-500/50 decoration-2" data-id="element-164">
              $29.99 USD
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mb-4 md:mb-8" data-id="element-165">
          <CTAButton href={checkoutLink} className="w-full max-w-lg py-5 text-xl md:text-2xl italic shadow-[0_0_30px_rgba(22,163,74,0.3)] mb-4" data-id="element-166">
            Sí, quiero mi Mega Pack →
          </CTAButton>
          <p className="text-gray-400 text-sm font-medium uppercase tracking-wider" data-id="element-167">
            Pagarás en la moneda de tu país
          </p>
        </div>

        {/* Pack Includes */}
        <div className="max-w-3xl mx-auto bg-[#111638] border border-gray-800 rounded-xl p-4 md:p-8 shadow-2xl" data-id="element-168">
          <h4 className="text-white font-bold text-center mb-3 md:mb-6 text-xl uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-169">
            👑 EL MEGA PACK INCLUYE:
          </h4>
          <ul className="space-y-2 md:space-y-4" data-id="element-170">
            {['Kit completo de Herrería y Carpintería', '+1500 planos de muebles de melamina', 'Planos de máquinas de gym', 'Planos de trailers profesionales', 'BONUS: Soldador Desde Cero', 'BONUS: Herrero Desde Cero', 'Entrega digital en PDF mediante Drive', 'Acceso de por vida — sin vencimiento', 'Garantía de satisfacción de 7 días'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-171">
                <div className="bg-[#f97316] rounded flex-shrink-0 mt-1 w-5 h-5 flex items-center justify-center" data-id="element-172">
                  <Check className="w-3.5 h-3.5 text-white" strokeWidth={4} data-id="element-173" />
                </div>
                <span className="text-gray-300 text-base md:text-lg" data-id="element-174">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}